import {LocalStorage} from 'quasar'

export default {
  // VARIAVEIS QUE TEM DENTRO DA SESSAO
  ano: LocalStorage.get.item('anoCorrente'),
  administracao: LocalStorage.get.item('administracaoCorrente'),
  usuario: LocalStorage.get.item('usuario'),
  coduser: LocalStorage.get.item('coduser')
}
